import { gql } from '@apollo/client';

export type {
  SendPasswordSetupEmail as ISendPasswordSetupEmail,
  SendPasswordSetupEmailVariables as ISendPasswordSetupEmailVariables,
} from './__generated__/SendPasswordSetupEmail';

export const SEND_PASSWORD_SETUP_EMAIL = gql`
  mutation SendPasswordSetupEmail($email: String!) {
    sendPasswordSetupEmail(email: $email)
  }
`;
